import { Component, Input, OnInit } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { Subscription } from "rxjs";
import { SearchData } from "src/app/services/searchData";
import { UtilService } from 'src/app/services/util.service';
import { ApiService } from './../../../services/api.service';
import { NG_ICON_DIRECTIVES } from '@ng-icons/core';


@Component({
  selector: "app-team-side-bar-nav",
  standalone: true,
  imports: [CommonModule,
    NG_ICON_DIRECTIVES,
  ],
  templateUrl: "./team-side-bar-nav.component.html",
  styleUrls: ["./team-side-bar-nav.component.scss"],
})
export class TeamSideBarNavComponent implements OnInit {
  pathdata: any;
  menuSelected: any;
  membermenuflag: boolean = true;
  pendingCount: any;
  teamOwnerFlag: boolean = false;
  countrEmitter: Subscription;
  @Input()
  userDataInput: string;
  menus = "home";
  commonVariables: any = {};
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private SearchData: SearchData,
    private util: UtilService,
    private api: ApiService) {
    this.countrEmitter = this.SearchData.getCommonVariables().subscribe(
      (res) => {
        this.pendingCount = res.pendingCount;
      }
    );
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.currentRoute = event.url;
        this.openSectionForUrl(event.url);
      }
    });
  }

  // Expand the Members section when the URL is its sub-page. Only ever opens;
  // it never forces the section closed, so navigating via the label does not
  // undo an arrow click.
  openSectionForUrl(url: string) {
    if (url.includes('/teamPage/inviteSent')) {
      this.membermenuflag = false;
    }
  }

  // Arrow click: flip the section open/closed and nothing else.
  toggleSubMenu(event?: Event) {
    if (event) {
      event.stopPropagation();
    }
    this.membermenuflag = !this.membermenuflag;
  }

  ngOnInit() {
    this.currentRoute = this.router.url;
    this.openSectionForUrl(this.currentRoute);
    this.route.queryParams.subscribe((res) => {
      this.pathdata = res;
      this.menus = this.userDataInput;
      if (res.teamsOwnerId === localStorage.getItem("userId")) {

        this.teamOwnerFlag = true;
        if (this.menus == "member") {
          this.membermenuflag = false;
        }
        else if (this.menus == "members") {
          this.membermenuflag = false;
        } else if (this.menus == "inviteSent") {
          this.membermenuflag = false;
        }

      }

      const usId = localStorage.getItem("userId");
      this.api.query("teams/member/invites/sent/" + this.pathdata.teamId).subscribe((res: any) => {
        if (res.data && res.data.TeamsMember != null) {
          this.commonVariables.pendingCount = res.data.TeamsMember.length;
          this.SearchData.setCommonVariables(this.commonVariables);
        }
      }, err => {
        this.util.stopLoader();
      });

    });



  }
  menuclick(name) {
    let values: any = {};
    this.menus = name;
    let x = JSON.parse(JSON.stringify(this.pathdata));
    values = x
    this.router.navigate(["teamPage/" + name], { queryParams: values });
  }
  currentRoute: string;

  isChildActive(parentRoute: string): boolean {
    return this.currentRoute.startsWith(parentRoute);
  }
}
